// The "changed today" register — zone identity phase 6 (docs/reference/
// zone_and_settings_changes.md §5). What was saved today that the stored figures only
// take in tonight: a zone's type, money / opening hours / thresholds / Allen context.
// Backend: GET /api_db/changes_today/ (applicaite/changes_today.py). The screens use
// zones/changesToday.js to decide what to show.
import { defineStore } from 'pinia'

import { apiClientDB } from '@/config_sessions'

const EMPTY = { zones: {}, settings: {} }

export const useChangesTodayStore = defineStore('changesToday', {
  state: () => ({ register: EMPTY, companyId: null, loadedAt: 0 }),

  actions: {
    async fetch(companyId = null) {
      try {
        const r = await apiClientDB.get('/changes_today/', {
          headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
        })
        this.register = (r.data && typeof r.data === 'object') ? r.data : EMPTY
      } catch (e) {
        this.register = EMPTY              // a notice is optional: never break a page
      }
      this.companyId = companyId
      this.loadedAt = Date.now()
      return this.register
    },

    // Once per company per minute — a zone saved in another tab shows on the next visit.
    async ensureLoaded(companyId) {
      if (this.companyId === companyId && Date.now() - this.loadedAt < 60000) return this.register
      return this.fetch(companyId)
    },
  },
})
